import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import {
  FaArrowLeft,
  FaPaperclip,
  FaChevronDown,
  FaRegFilePdf,
  FaCamera,
} from "react-icons/fa";
import { IoSend } from "react-icons/io5";
import APIURL from "../../common/Config";
import Header from "../header/header";
import "./webchat.css";
import toast from 'react-hot-toast';

const WebChatScreen = () => {
  const { sessionId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState("");
  const [msgCategory, setMsgCategory] = useState("INIT");
  const [showScrollDown, setShowScrollDown] = useState(false);
  const [showEndDialog, setShowEndDialog] = useState(false);
  const [statusModal, setStatusModal] = useState({
    visible: false,
    message: "",
  });
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const [astroName, setAstroName] = useState("Astrologer");
  const [astroImage, setAstroImage] = useState("");

  const chatEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  const isFetching = useRef(false);

  const welcomeRef = useRef({ msg2: null, msg3: null });
  const msg2ShownRef = useRef(false);
  const msg3ShownRef = useRef(false);

  const sessionData = location.state?.paramKey || { sessionId };


  useEffect(() => {
    const customerId = localStorage.getItem("customerId");
    if (!customerId || customerId === "undefined") {
      navigate("/login");
      return;
    }
    const storedName = localStorage.getItem("astrologerName");
    const storedImage = localStorage.getItem("astrologerImage");
    if (storedName) setAstroName(storedName);
    if (storedImage && storedImage !== "null") setAstroImage(storedImage);
  }, [navigate]);

  useEffect(() => {
    const welcomeMap = sessionData?.welcomeMessagesMap || {};
    const t2 = setTimeout(() => {
      if (!msg2ShownRef.current && welcomeMap.msg2) {
        welcomeRef.current.msg2 = {
          id: "welcome-2",
          text: welcomeMap.msg2,
          sender: "SYSTEM",
          time: moment().format("hh:mm A"),
          receiveTime: new Date().toISOString(),
          fullDate: moment().format("DD-MM-YYYY"),
          dateLabel: "Today",
          type: "message",
        };
        msg2ShownRef.current = true;
        fetchMessages(false);
      }
    }, 30000);

    const t3 = setTimeout(() => {
      if (!msg3ShownRef.current && welcomeMap.msg3) {
        welcomeRef.current.msg3 = {
          id: "welcome-3",
          text: welcomeMap.msg3,
          sender: "SYSTEM",
          time: moment().format("hh:mm A"),
          receiveTime: new Date().toISOString(),
          fullDate: moment().format("DD-MM-YYYY"),
          dateLabel: "Today",
          type: "message",
        };
        msg3ShownRef.current = true;
        fetchMessages(false);
      }
    }, 60000);

    return () => {
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [sessionData]);

  const closeChatApi = async () => {
    try {
      await axios.post(`${APIURL}/astrochat2026/sendchatmsg`, {
        msgCatg: "Close",
        astrologerId: sessionData.astrologerId,
        customerId: localStorage.getItem("customerId"),
        messageText: "Chat ended by user.",
        messageSender: "CUSTOMER",
        sessionId: sessionId,
      });
      navigate(`/feedback/${sessionId}`, {
        state: {
          astrologerId: sessionData.astrologerId,
          astrologerName: astroName,
          endMessage: "Chat ended by user.",
        },
      });
    } catch (error) {
      navigate(`/feedback/${sessionId}`);
    }
  };

  const handleKeyDown = (e) => {
   
    if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault(); 
        sendMessage();     
    }
   
};
  const checkSessionStatus = async () => {
    try {
      const res = await axios.get(
        `${APIURL}/astrochat2026/chat/session/${sessionId}/status`,
      );
      if (res.data) {
        const currentStatus = res.data.statusDescp;
        if (currentStatus === "COMPLETED" || currentStatus === "ENDED") {
          navigate(`/feedback/${sessionId}`, {
            state: {
              astrologerId: sessionData.astrologerId,
              astrologerName: astroName,
              endMessage: "Chat ended by astrologer.",
            },
          });
        }
        if (currentStatus === "WARNED") {
          setStatusModal({
            visible: true,
            message: res.data.message || "Session expiring soon!",
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const statusInterval = setInterval(checkSessionStatus, 5000);
    return () => clearInterval(statusInterval);
  }, [sessionId]);

  const formatLine = (label, value = "") => {
    const labelPad = 15;
    return `${label.padEnd(labelPad)}: ${value || ""}\n`;
  };

  const handleFileAction = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    setUploading(true);
    try {
      await axios.post(
        `${APIURL}/astrochat2026/sendfilemsg?msgCatg=Msg&sessionId=${sessionId}&customerId=${localStorage.getItem("customerId")}&astrologerId=${sessionData.astrologerId}&messageSender=CUSTOMER`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      fetchMessages();
    } catch (err) {
      alert("Upload Failed");
    } finally {
      setUploading(false);
    }
  };

  const fetchMessages = async (forceScroll = false) => {
    if (isFetching.current) return;
    isFetching.current = true;
    try {
      const res = await axios.get(
        `${APIURL}/astrochat2026/getmsglist/${sessionId}`,
      );
      if (res.data && Array.isArray(res.data)) {
        if (res.data.length > 0) {
          if (res.data[0].astrologerName)
            setAstroName(res.data[0].astrologerName);
          if (res.data[0].photoUrlPath) setAstroImage(res.data[0].photoUrlPath);
        }

        const lastAction = [...res.data]
          .reverse()
          .find((m) => ["ACCEPT", "MSG"].includes(m.msgCatg?.toUpperCase()));
        const currentCatg = lastAction
          ? lastAction.msgCatg.toUpperCase()
          : "INIT";
        setMsgCategory(currentCatg);

        const formatted = res.data.map((msg) => {
          const messageDate = moment(msg.receiveTime);
          let displayContent = "";
          if (msg.msgCatg === "INIT") {
            try {
              const p =
                typeof msg.messageText === "string"
                  ? JSON.parse(msg.messageText)
                  : msg.messageText;
              displayContent =
                `Below are my details:\n` +
                formatLine("Name", p?.firstName) +
                formatLine("Gender", p?.gender) +
                formatLine("Status", p?.mStatus) +
                formatLine("Occupations", p?.oc) +
                formatLine(
                  "DOB",
                  p?.dob ? moment(p.dob).format("DD-MM-YYYY") : "",
                ) +
                formatLine("TOB", p?.timeOfBirth || p?.tob) +
                formatLine("POB", p?.city || p?.pob);
            } catch (e) {
              displayContent = "User details shared.";
            }
          } else {
            displayContent =
              typeof msg.messageText === "object"
                ? JSON.stringify(msg.messageText)
                : String(msg.messageText);
          }
          return {
            id: msg.msgid,
            text: displayContent,
            sender: msg.msgCatg === "INIT" ? "CUSTOMER" : msg.senderCatg,
            time: messageDate.format("hh:mm A"),
            msgCatg: msg.msgCatg?.toUpperCase(),
            fileUrl: msg.fileUrl,
            receiveTime: msg.receiveTime,
            fullDate: messageDate.format("DD-MM-YYYY"),
            dateLabel: messageDate.isSame(moment(), "day")
              ? "Today"
              : messageDate.isSame(moment().subtract(1, "day"), "day")
                ? "Yesterday"
                : messageDate.format("DD MMM YYYY"),
          };
        });

        const welcomeMap = sessionData?.welcomeMessagesMap || {};
        const msg1 = {
          id: "welcome-1",
          text: welcomeMap["msg1"] || "Welcome!",
          sender: "ASTROLOGER_JOIN",
          time: moment(sessionData.receiveTime || new Date()).format("hh:mm A"),
          msgCatg: "WELCOME",
          receiveTime: sessionData.receiveTime || new Date().toISOString(),
          fullDate: moment(sessionData.receiveTime).format("DD-MM-YYYY"),
          dateLabel: "Today",
        };

        // --- SIR'S LOGIC: Only show Queue/Wait messages if Astrologer has NOT joined ---
        const welcomeMsgs = [];
        if (currentCatg === "INIT") {
          if (welcomeRef.current.msg2)
            welcomeMsgs.push(welcomeRef.current.msg2);
          if (welcomeRef.current.msg3)
            welcomeMsgs.push(welcomeRef.current.msg3);
        }

        let combined = [msg1, ...formatted, ...welcomeMsgs]
          .filter(Boolean)
          .sort((a, b) => new Date(a.receiveTime) - new Date(b.receiveTime));

        const grouped = [];
        let lastDate = "";
        combined.forEach((m) => {
          if (m.fullDate !== lastDate) {
            grouped.push({
              type: "DATE_LABEL",
              label: m.dateLabel,
              id: `date-${m.fullDate}`,
            });
            lastDate = m.fullDate;
          }
          grouped.push(m);
        });
        setMessages(grouped);
      }
    } catch (error) {
      console.error(error);
    } finally {
      isFetching.current = false;
    }
  };

  useEffect(() => {
    fetchMessages();
    const interval = setInterval(fetchMessages, 5000);
    return () => clearInterval(interval);
  }, [sessionId]);

  const sendMessage = async () => {
    if (!inputText.trim()) return;
    const payload = {
        msgCatg: "MSG",
        astrologerId: sessionData.astrologerId,
        customerId: localStorage.getItem("customerId"),
        messageText: inputText,
        messageSender: "CUSTOMER",
        sessionId: sessionId,
    };
    try {
        const res = await axios.post(`${APIURL}/astrochat2026/sendchatmsg`, payload);
        
        // NATIVE LOGIC: Agar chat ke beech mein balance khatam hua ya low hua
        if (res.data?.messageSender === 'ADMIN') {
            toast((t) => (
                <span>
                    {res.data.messageText}
                    <button 
                        onClick={() => { toast.dismiss(t.id); navigate("/wallet"); }}
                        style={{ marginLeft: '10px', background: '#89184a', color: '#fff', border: 'none', padding: '5px 10px', borderRadius: '4px' }}
                    >
                        Recharge
                    </button>
                </span>
            ), { duration: 6000 });
            return;
        }

        setInputText("");
        fetchMessages();
        chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    } catch (error) {
        console.error(error);
        toast.error("Message send failed.");
    }
};
  // const sendMessage = async () => {
  //   if (!inputText.trim()) return;
  //   const payload = {
  //     msgCatg: "MSG",
  //     astrologerId: sessionData.astrologerId,
  //     customerId: localStorage.getItem("customerId"),
  //     messageText: inputText,
  //     messageSender: "CUSTOMER",
  //     sessionId: sessionId,
  //   };
  //   try {
  //     await axios.post(`${APIURL}/astrochat2026/sendchatmsg`, payload);
  //     setInputText("");
  //     fetchMessages();
  //     chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  return (
    <div className="ws-page-bg">
      <Header />
      <div className="ws-content-box">
        <div className="ws-chat-card">
          <div className="ws-header">
            <FaArrowLeft
              onClick={() => setShowEndDialog(true)}
              className="ws-back-trigger"
            />
            <div className="ws-astro-avatar">
              <img
                src={
                  astroImage ||
                  "https://astrobhagya.co.in/contents/profile/default.png"
                }
                alt="Astro"
                onError={(e) => {
                  e.target.src =
                    "https://astrobhagya.co.in/contents/profile/default.png";
                }}
              />
              <div className="ws-online-dot"></div>
            </div>
            <div className="ws-astro-meta">
              <span className="ws-astro-name">{astroName}</span>
              <span className="ws-astro-status">Online</span>
            </div>
          </div>

          <div
            className="ws-viewport"
            ref={chatContainerRef}
            onScroll={(e) => {
              const nearBottom =
                e.target.scrollHeight - e.target.scrollTop <=
                e.target.clientHeight + 100;
              setShowScrollDown(!nearBottom);
            }}
          >
            {messages.map((msg, i) =>
              msg.type === "DATE_LABEL" ? (
                <div key={msg.id} className="ws-date-sep">
                  <span>{msg.label}</span>
                </div>
              ) : (
                <div
                  key={i}
                  className={`ws-msg-row ${msg.sender === "CUSTOMER" ? "ws-right" : "ws-left"}`}
                >
                  <div className="ws-msg-bubble">
                    {msg.fileUrl ? (
                      msg.fileUrl.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                        <img
                          src={msg.fileUrl}
                          className="ws-chat-img"
                          alt="img"
                          style={{ maxWidth: "100%", borderRadius: "10px" }}
                        />
                      ) : (
                        <a
                          href={msg.fileUrl}
                          target="_blank"
                          rel="noreferrer"
                          className="ws-pdf-pill"
                          style={{
                            color:
                              msg.sender === "CUSTOMER" ? "#fff" : "#89184a",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            textDecoration: "none",
                          }}
                        >
                          <FaRegFilePdf /> View Document
                        </a>
                      )
                    ) : (
                      <pre className="ws-pre-wrap">{msg.text}</pre>
                    )}
                    <span className="ws-msg-time">{msg.time}</span>
                  </div>
                </div>
              ),
            )}
            <div ref={chatEndRef} />
          </div>

          {showScrollDown && (
            <div
              className="ws-scroll-btn"
              onClick={() =>
                chatEndRef.current?.scrollIntoView({ behavior: "smooth" })
              }
            >
              <FaChevronDown />
            </div>
          )}

          <div className="ws-footer">
            <input
              type="file"
              ref={fileInputRef}
              hidden
              onChange={handleFileAction}
              accept="image/*,application/pdf"
            />
            <button
              className="ws-attach-btn"
              onClick={() => fileInputRef.current.click()}
              disabled={uploading}
            >
              <FaPaperclip
                color={msgCategory === "INIT" ? "#ccc" : "#89184a"}
              />
            </button>
            <textarea
              className="ws-input-field"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder={
                msgCategory === "INIT"
                  ? "Waiting for astrologer..."
                  : "Type your message..."
              }
              disabled={msgCategory === "INIT" && messages.length > 10}
            />
            <button
              className="ws-send-trigger"
              onClick={sendMessage}
              disabled={!inputText.trim() || uploading}
            >
              <IoSend />
            </button>
          </div>
        </div>
      </div>

      {showEndDialog && (
        <div className="ws-modal-mask">
          <div className="ws-modal-box">
            <div className="ws-modal-alert">!</div>
            <h3>End Chat Session?</h3>
            <p style={{ color: "gray", marginBottom: "20px" }}>
              Would you like to end the session with {astroName}?
            </p>
            <button className="ws-confirm" onClick={closeChatApi}>
              Yes, End Chat
            </button>
            <button
              className="ws-cancel"
              onClick={() => setShowEndDialog(false)}
            >
              No, Continue
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WebChatScreen;
